import sanitizeHtml from 'sanitize-html'

interface ISanitizeSettings {
  defaultTagWhitelist?: Array<string>,
  nonTextTagBlacklist?: Array<string>,
  allowedClassesObject?: any,
  allowedAttributesObject?: any,
}

export const createAndSanitizeMarkup = (dirtyPayload?: string, sanitizeSettings?: ISanitizeSettings) => {
  if (!dirtyPayload) {
    return { __html: '<div>No Message Found</div>' }
  }

  const defaultTagWhitelist = ['div', 'p', 'li', 'ol', 'ul', 'a', 'br', 'b', 'i', 'em', 'strong']
  const nonTextTagBlacklist = ['style', 'script', 'textarea', 'option', 'img']
  const allowedClassesObject = {
    a: [
      'ch-c-button',
      'ds-c-button',
      'ch-c-render-html__btn-cta',
      'ch-c-button--primary',
      'ds-c-button--solid'
    ],
    div: [
      'ch-c-render-html__flex-2',
      'ds-u-margin-bottom--2',
      'ds-u-border--1',
      'ds-u-border-color--gray',
      'ds-u-radius',
      'ds-u-padding--2',
      'ch-u-box-shadow'
    ],
    p: ['ds-u-margin--0']
  }
  const allowedAttributesObject = {
    a: ['href']
  }

  const cleanPayload = sanitizeHtml(dirtyPayload, {
    allowedTags: sanitizeSettings?.defaultTagWhitelist ?? defaultTagWhitelist,
    allowedAttributes: sanitizeSettings?.allowedAttributesObject ?? allowedAttributesObject,
    allowedClasses: sanitizeSettings?.allowedClassesObject ?? allowedClassesObject,
    nonTextTags: sanitizeSettings?.nonTextTagBlacklist ?? nonTextTagBlacklist,
    disallowedTagsMode: 'discard'
  })

  return { __html: cleanPayload }
}
